import ServiceTemplate from '@/components/ServiceTemplate';

export default function CopyrightEnforcement() {
  const data = {
    title: 'Copyright Enforcement Services',
    subtitle: 'Protect your creative works with professional copyright enforcement and infringement action.',
    overviewTitle: 'Enforcing Your Copyright Rights',
    overviewImage: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800',
    description: [
      'Copyright enforcement protects your creative works from unauthorized use, ensuring you receive proper compensation and recognition for your creations. Timely enforcement is essential to stop infringement and preserve copyright value.',
      'Our copyright enforcement service handles all aspects of protecting your rights including infringement identification, cease and desist actions, DMCA takedowns, and litigation when necessary.',
      'We take swift, effective action against copyright infringement to protect your creative works and maintain control over how they are used and distributed.'
    ],
    benefits: [
      { title: 'Infringement Action', description: 'Swift response to unauthorized use of your work.' },
      { title: 'DMCA Takedowns', description: 'Remove infringing content from websites and platforms.' },
      { title: 'Cease and Desist', description: 'Formal demands to stop infringement.' },
      { title: 'Litigation Support', description: 'Experienced copyright litigation representation.' },
      { title: 'Damage Recovery', description: 'Pursue compensation for infringement.' },
      { title: 'Settlement Negotiation', description: 'Achieve favorable settlements when appropriate.' }
    ],
    process: [
      { title: 'Case Evaluation & Evidence', description: 'Comprehensive analysis of infringement and collection of supporting evidence.' },
      { title: 'Strategic Action & Negotiation', description: 'Enforcement action implementation and settlement negotiations with infringers.' },
      { title: 'Resolution & Protection', description: 'Securing favorable outcome and implementing ongoing protection measures.' }
    ],
    pricing: [
      {
        name: 'Basic',
        description: 'Single work registration',
        price: '$199',
        period: '+ filing fees ($45-$65)',
        features: [
          'Single work registration',
          'Copyright Office filing',
          'Application preparation',
          'Certificate delivery',
          'Email support',
          'Standard processing'
        ]
      },
      {
        name: 'Professional',
        description: 'Multi-work package',
        price: '$399',
        period: '+ filing fees',
        featured: true,
        features: [
          'Up to 5 works registration',
          'Expedited filing available',
          'Comprehensive documentation',
          'Priority processing',
          'Copyright monitoring (6 months)',
          'Phone support',
          'Enforcement consultation'
        ]
      },
      {
        name: 'Enterprise',
        description: 'Portfolio management',
        price: '$799',
        period: '+ filing fees',
        features: [
          'Unlimited registrations',
          'Portfolio strategy planning',
          'Ongoing monitoring',
          'DMCA takedown services',
          'Infringement detection',
          'Legal representation',
          'Dedicated account manager'
        ]
      }
    ],
    faqs: [
      { question: 'What is copyright infringement?', answer: 'Infringement occurs when someone reproduces, distributes, displays, or creates derivatives of copyrighted work without permission.' },
      { question: 'What is a DMCA takedown?', answer: 'Digital Millennium Copyright Act takedown notices request removal of infringing content from websites and online platforms.' },
      { question: 'Do I need registration to enforce?', answer: 'Registration is required to file copyright infringement lawsuits in federal court, though cease and desist letters don\'t require registration.' },
      { question: 'What damages can I recover?', answer: 'Options include actual damages plus infringer\'s profits, or statutory damages up to $150,000 per work for willful infringement, plus attorney fees.' },
      { question: 'How long do I have to sue?', answer: 'Copyright infringement claims must be filed within 3 years of discovering the infringement.' },
      { question: 'What is fair use?', answer: 'Fair use allows limited use without permission for purposes like criticism, commentary, news reporting, teaching, or research.' },
      { question: 'Can I settle infringement cases?', answer: 'Yes, many cases settle through licensing arrangements, payment of damages, or other negotiated resolutions.' },
      { question: 'What if infringer is overseas?', answer: 'International enforcement can be challenging. DMCA takedowns and platform complaints are often most effective for online infringement.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
